import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class OutsideListener extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    handleClickOutside: PropTypes.func.isRequired,
    refs: PropTypes.arrayOf(
      PropTypes.shape({
        current: PropTypes.object,
      })
    ),
  };

  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
    this.ref = React.createRef();
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClick);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClick);
  }

  handleClick(event) {
    if (this.ref && this.ref.current) {
      const refs = this.props.refs || [];
      refs.push(this.ref);

      if (refs.every(ref => !ref.current.contains(event.target))) {
        this.props.handleClickOutside();
      }
    }
  }

  render() {
    return <div ref={this.ref}>{this.props.children}</div>;
  }
}
